module.exports = __webpack_public_path__ + "9a2c8a10b28d2d1ab5a1d652210ebc44.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gabriel-main-768.jpg
// module id = 329
// module chunks = 0